var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 3.44531C6.25391 3.23438 6.5 3.09375 6.78125 3.09375H15.2188C15.4648 3.09375 15.7109 3.23438 15.8867 3.44531L19.8242 8.78906C20.0703 9.10547 20.0352 9.5625 19.7539 9.87891L11.5977 18.8789C11.457 19.0547 11.2109 19.1602 11 19.1602C10.7539 19.1602 10.5078 19.0547 10.3672 18.8789L2.21094 9.87891C1.92969 9.5625 1.89453 9.10547 2.14062 8.78906L6.07812 3.44531ZM7.44922 4.85156C7.30859 4.95703 7.30859 5.09766 7.37891 5.23828L9.38281 8.57812L4.21484 9C4.07422 9.03516 3.96875 9.14062 3.96875 9.28125C3.96875 9.45703 4.07422 9.5625 4.21484 9.5625L10.9648 10.125H11L17.75 9.5625C17.8906 9.5625 17.9961 9.45703 17.9961 9.28125C17.9961 9.14062 17.8906 9.03516 17.75 9L12.582 8.57812L14.5859 5.23828C14.6914 5.09766 14.6562 4.95703 14.5156 4.85156C14.4102 4.78125 14.2344 4.78125 14.1641 4.88672L11 8.33203L7.80078 4.88672C7.73047 4.78125 7.55469 4.78125 7.44922 4.85156Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default ForwardRef;